import React, { useState } from 'react';
import { View, ScrollView } from 'react-native';
import NavigateRow from '../NavigateRow';
import TermsModal from './legal/TermsModal';
import PrivacyModal from './legal/PrivacyModal';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import { Screens } from '../../constants/ScreenNames';

const LegalModal = (props) => {
  const { tKey } = useComponentTKey('LegalModal');
  const { t } = useTranslation(i18nNS.settings);
  const [termsModalVisible, setTermsVisible] = useState(false);
  const [privacyModalVisible, setPrivacyVisible] = useState(false);

  const onTermsPress = () => {
    props.navigation.navigate(Screens.TermsOfUse);
  };
  const onPrivacyPress = () => {
    props.navigation.navigate(Screens.PrivacyPolicy);
  };

  return (
    <View>
      <ScrollView>
        <NavigateRow text={t(tKey('TermsOfUse'))} disableAnimation onPressCallback={onTermsPress} />
        <NavigateRow
          text={t(tKey('PrivacyPolicy'))}
          disableAnimation
          onPressCallback={onPrivacyPress}
        />
      </ScrollView>
      {termsModalVisible && (
        <TermsModal
          onClose={() => {
            setTermsVisible(false);
          }}
        />
      )}
      {privacyModalVisible && (
        <PrivacyModal
          onClose={() => {
            setPrivacyVisible(false);
          }}
        />
      )}
    </View>
  );
};

export default LegalModal;
